/* eslint-disable no-nested-ternary */
import React, {useCallback, useState} from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import CloudImage from 'assets/svgs/file-upload/cloud.svg';
import {ReactComponent as File} from 'assets/svgs/file-upload/file.svg';
import {useDropzone} from 'react-dropzone';
import {makeSelectBasicUser} from 'reducers/selectors/userSelectors';
import {useSelector} from 'react-redux';
import SingleFile from './SingleFile';
import './style.scss';

const basicUserSelector = makeSelectBasicUser();

const FileUpload = ({onClose, selected, companyId, onFileUpload}) => {
  const userDetails = useSelector(basicUserSelector);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [uploaded, setUploaded] = useState(0);
  const fileState = {
    Select: 'SELECT',
    Uploading: 'UPLOADING',
    Uploaded: 'UPLOADED',
    Server: 'SERVER',
    uploadFile: 'FILE',
  };

  const [currentSection, setCurrentSection] = useState(fileState.uploadFile);

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles.length === 0) return;

    setCurrentSection(fileState.Uploading);
    setSelectedFiles(acceptedFiles);
    setUploaded(0);
  }, []);

  const {getRootProps, getInputProps} = useDropzone({
    onDrop,
    accept: 'image/jpeg, image/webp,image/png, image/svg+xml, application/pdf',
  });

  const renderDropzone = () => (
    <div className="featured-img-uploaded upload-modal w-100">
      <div className="uploaded-img d-flex justify-content-center">
        <div {...getRootProps()} className="w-100">
          {fileState.uploadFolder === currentSection ? (
            <input {...getInputProps()} directory="" webkitdirectory="" />
          ) : (
            <input {...getInputProps()} />
          )}

          <div className="d-flex justify-content-center align-items-center flex-column h-100">
            <img alt="test" src={CloudImage} />
            <p className="px-1 mt-2">
              Drag and Drop or <span className="text-gold">Browse</span> to
              upload
            </p>
          </div>
        </div>
      </div>
    </div>
  );

  const renderUploading = () => (
    <div className="d-flex w-100 uploading-section flex-column bg-white">
      <div className="w-100 py-3 bg-gray4 px-4 border-bottom">
        {`Uploading ${selectedFiles.length} files`}
      </div>

      {selectedFiles.map((f) => (
        <React.Fragment key={f.lastModified + f.name}>
          <SingleFile
            selected={selected}
            file={f}
            basicUser={userDetails}
            companyId={companyId}
            categoryType={selected.type}
            folderId={selected ? selected._id : undefined}
            pageFolderId={selected.pageFolderId}
            onUpload={(file) => {
              onFileUpload(file);
              setUploaded((old) => {
                if (
                  parseInt(old, 10) + 1 === selectedFiles.length ||
                  uploaded === selectedFiles.length
                ) {
                  onClose();
                }
                return parseInt(old, 10) + 1;
              });
            }}
          />
        </React.Fragment>
      ))}
    </div>
  );

  const renderSections = () => {
    switch (currentSection) {
      case fileState.uploadFile:
      case fileState.uploadFolder:
        return renderDropzone();
      case fileState.Uploading:
        return renderUploading();
      default:
        return null;
    }
  };
  return (
    <div className="featured-img-popup">
      <div className="overlay"></div>

      <div className="box-popup d-flex justify-content-center align-items-center">
        <OutsideClickHandler
          onOutsideClick={() => {
            onClose();
          }}
        >
          <>
            <div className="content-popup small">
              <div className="d-flex">
                {currentSection !== fileState.Uploading && (
                  <div className="tab-nav position-relative">
                    <ul
                      className="nav nav-pills m-0"
                      id="pills-tab"
                      role="tablist"
                    >
                      <li className="nav-item">
                        <a
                          className="nav-link  active pt-4 align-items-start"
                          data-toggle="pill"
                          href="#test"
                          onClick={(e) => {
                            e.preventDefault();
                            if (currentSection === fileState.Uploading) return;
                            setCurrentSection(fileState.uploadFile);
                          }}
                          role="tab"
                          aria-controls="pills-select-logo"
                          aria-selected="false"
                        >
                          <File className="mr-2" />
                          <span className="tab-text"> Upload file</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                )}
                <div className="tab-content file-tabs" id="pills-tabContent">
                  <div
                    className={`tab-pane d-flex h-100 justify-content-center align-items-center ${
                      currentSection === fileState.Uploading ? '' : 'px-4'
                    }`}
                    id="pills-upload-logo"
                    role="tabpanel"
                    aria-labelledby="pills-upload-logo-tab"
                  >
                    {renderSections()}
                  </div>
                </div>
              </div>
            </div>
          </>
        </OutsideClickHandler>
      </div>
    </div>
  );
};

export default FileUpload;
